import React, { useEffect, useState } from 'react';
import { Card, Col, Row } from 'antd';
import useStatsStore from "../../store/stats.store"
import "./InterviewCountCard.scss"
function InterviewCountCard() {
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    const {interviewSchedules,getInterviewSchedule } = useStatsStore();
    const [interviewCount, setInterviewCount] = useState({
        L0: 0,
        L1: 0,
        L2: 0,
        Customer: 0,
        HR: 0,
        Management: 0,
    });

    useEffect(() => {
        getInterviewSchedule();
        console.log("hey")
    },[])

    useEffect(() => {
        updateInterviewCount(interviewSchedules);
        console.log("you")
    }, [interviewSchedules]);

    const TotalInterviews = () => { 
        return interviewSchedules?.JDListInterview?.reduce((total, item) => {
            return total + item.InterviewItem?.length;
        }, 0)
    }

    const YourInterviews = () => {
        return interviewSchedules?.JDListInterview?.reduce((total, item) => {
            console.log(item.assignedto,userDetails.username, "I m c hec king this")
            return total + (item.assignedto === userDetails.username ? item.InterviewItem?.length : 0);
        },0)
    }

    const getCurrentDate = () => {
        const today = new Date();
        const day = String(today.getDate()).padStart(2, '0');
        const month = String(today.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        const year = today.getFullYear();
        
        return `${day}-${month}-${year}`;
    };

    const getInterviewsToday = () => {
        const today = getCurrentDate();
        return interviewSchedules?.JDListInterview?.reduce((total, item) => {
            return total + (item.InterviewItem?.reduce((itemTotal, interview) => {
                return itemTotal + (interview.interviewdate === today ? 1 : 0);
            }, 0))
        }, 0);
    };

    const updateInterviewCount = () => {
    const count = {
        L0: 0,
        L1: 0,
        L2: 0,
        Customer: 0,
        HR: 0,
        MgMT: 0,
    };

    interviewSchedules?.JDListInterview.forEach(job => {
        job.InterviewItem.forEach(interview => {
            if (count.hasOwnProperty(interview.type)) {
                count[interview.type] += 1;
            }
        });
    });
    setInterviewCount(count);
};

  return (
    <div className="interview-count-card-wrapper">
        <Row gutter={0}>
            <Col span={3}>
                <Card className='interview-count-card' title="Total Interviews" variant="borderless">
                    {TotalInterviews()}
                </Card>
            </Col>
            <Col span={3}>
                <Card className='interview-count-card' title="Interviews Today" variant="borderless">
                    {getInterviewsToday()}
                </Card>
            </Col>
            <Col span={3}>
                <Card className='interview-count-card' title="L0 Interviews" variant="borderless">
                {interviewCount.L0}
                </Card>
            </Col>
            <Col span={3}>
                <Card className='interview-count-card' title="L1 Interviews" variant="borderless">
                {interviewCount.L1}
                </Card>
            </Col>
            <Col span={3}>
                <Card className='interview-count-card' title="L2 Interviews" variant="borderless">
                {interviewCount.L2}
                </Card>
            </Col>
            <Col span={3}>
                <Card className='interview-count-card' title="Customer Interivews" variant="borderless">
                {interviewCount.Customer}
                </Card>
            </Col>
            <Col span={3}>
                <Card className='interview-count-card' title="HR Interivews" variant="borderless">
                {interviewCount.HR}
                </Card>
            </Col>
            <Col span={3}>
                <Card className='interview-count-card' title="Management Interivews" variant="borderless">
                {interviewCount.MgMT}
                </Card>
            </Col>
        </Row>
    </div>
  )
}

export default InterviewCountCard